<template>
  <div class="asc-legend-list">
    <template v-if="isHeader">
      <div class="asc-legend-list--header">
        <asc-label
          uppercase
          :value="getHeader"
          size="md"
          color="#666"
        ></asc-label>
      </div>
    </template>

    <ul :class="[multipleColumns ? 'asc-legend-list--multiple-columns' : null]">
      <asc-legend-list-item
        v-for="item in items"
        :key="item.text"
        :text="item.text || item.id"
        :style-color="item.styleColor"
        :border-radius="item.borderRadius"
        :border="item.border"
        :icon="item.icon"
        :filter="filter"
        :is-selected="isItemSelected(item.text)"
        :on-item-click="onItemClick"
      ></asc-legend-list-item>
    </ul>
  </div>
</template>

<script>
import AscLabel from '@/components/atoms/AscLabel'
import AscLegendListItem from '@/components/atoms/AscLegendListItem'

export default {
  name: 'AscLegendList',

  components: { AscLabel, AscLegendListItem },

  props: {
    filter: {
      type: Boolean,
      default: false,
    },
    multipleColumns: {
      type: Boolean,
      default: true,
    },
    header: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    itemsSelected: {
      type: Array,
      default: () => [],
    },
    onItemClick: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    isHeader() {
      return this.header && this.header.length > 0
    },

    getHeader() {
      return this.header ? this.header : ''
    },
  },

  methods: {
    isItemSelected(status) {
      return this.itemsSelected.includes(status)
    },
  },
}
</script>

<style lang="scss">
.asc-legend-list {
  .asc-legend-list--header {
    margin-bottom: 12px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .asc-legend-list--multiple-columns {
    columns: 2;
  }
}
</style>
